import React from 'react';
import { COMPANY_NAME } from '../constants';

const AboutUs = () => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded shadow-md flex flex-col md:flex-row items-center md:items-start gap-6">
      <div className="md:w-1/2">
        <h2 className="text-3xl font-bold mb-4 text-gray-900">About {COMPANY_NAME}</h2>
        <p className="mb-3 text-gray-700">
          We are dedicated to delivering cutting-edge software solutions that empower businesses to thrive in the digital age.
        </p>
        <p className="mb-3 text-gray-700">
          Our vision is to innovate and lead in technology, providing value and excellence to our clients.
        </p>
        <p className="mb-3 text-gray-700">
          Our values include integrity, collaboration, and customer-centricity.
        </p>
      </div>
      <div className="md:w-1/2">
        <img
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80"
          alt="Corporate Team"
          className="rounded shadow-md w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default AboutUs;
